import type User from '@common/types/models/User';

export const ALLOW_ACCESS_CONTEXT_DEMO = 'access_context_demo';
export const DENY_REQUEST_ACCESS_BY_MAC = 'deny-request-access-by-mac';
export const DENY_VIEW_CLOUD_DEVICES = 'deny-view-cloud-devices';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const allPermissions = [
  ALLOW_ACCESS_CONTEXT_DEMO,
  DENY_REQUEST_ACCESS_BY_MAC,
  DENY_VIEW_CLOUD_DEVICES,
] as const;

type PermissionName = typeof allPermissions[number];

export type Permission = {
  name: PermissionName;
};

export const hasPermission = (
  user: User | undefined,
  permissionName: PermissionName,
) => user?.permissions?.some((item) => item.name === permissionName) ?? false;
